"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSFClientChain = exports.InternalCFClientChain = exports.InternalClientChainBase = void 0;
const Either = __importStar(require("fp-ts/Either"));
const uuid_1 = require("uuid");
class ActiveChain {
    constructor(chainKey) {
        this.pendingIndex = 0;
        this.chainKey = chainKey;
    }
}
class InternalClientChainBase {
    constructor(definition, channel) {
        this._activeChains = {};
        this.handleDropMessage = (key) => {
            this.releaseChain(key);
            delete this._activeChains[key];
        };
        this.dispatch = (message) => {
            if (!message.chain) {
                console.warn("Invalid dispatch - non-chain message dispatched to Client chain.");
                return;
            }
            if (message.chainID !== this._definition.id) {
                console.warn("Invalid dispatch - chain message sent to ClientChain with a different ID");
                return;
            }
            this.doDispatch(message);
        };
        this.doNext = (payload, key) => __awaiter(this, void 0, void 0, function* () {
            const chain = this._activeChains[key];
            if (chain === undefined) {
                this.dropChain(key);
                throw "Invalid chain - something called next() on a chain that doesn't exist."; // FIXME - make this a proper error
            }
            if (chain.pendingHandler !== undefined) {
                this.dropChain(key);
                throw "Invalid chain call - next() cannot be called twice on the same chain stage."; // FIXME - make this a proper error
            }
            //
            if (chain.pendingIndex === this._definition.chain.length - 1) {
                // We are about to send the last message, no response expected:
                this._channel.sendChain(this._definition.id, key, chain.pendingIndex, payload);
                delete this._activeChains[key]; // Not a drop - this is a normal-case deletion.
                // This return value resolves to 'never' from the client API for this handler. This is just to appease the compiler for our internal implementation.
                return {};
            }
            else {
                // We expect a response, must prepare the handler for it:
                return new Promise((resolve, reject) => {
                    chain.pendingHandler = (decodedPayload) => {
                        chain.pendingIndex++;
                        const nextStage = {
                            value: decodedPayload,
                            // This function may actually resolve to 'never' on the client API if we're at the end of a chain.
                            // This is fine, because it'll fall out of scope as soon as the chain ends and be garbage collected.
                            next: ((payload) => this.doNext(payload, key)),
                        };
                        chain.pendingHandler = undefined;
                        chain.abortHandler = undefined;
                        resolve(nextStage); // This type is indefinitely recursive so TS doesn't like it.
                    };
                    chain.abortHandler = () => reject("Chain Aborted");
                    //
                    const sendIndex = chain.pendingIndex;
                    chain.pendingIndex++;
                    this._channel.sendChain(this._definition.id, key, sendIndex, payload);
                });
            }
        });
        this.releaseChain = (key) => {
            const chain = this._activeChains[key];
            if (chain === undefined)
                return;
            if (chain.abortHandler)
                chain.abortHandler();
        };
        this.dropChain = (key) => {
            this.releaseChain(key);
            const chain = this._activeChains[key];
            if (chain !== undefined) {
                this._channel.client.notifyChainDrop(this._channel.namespace, this._channel.channelID, this._definition.id, chain.chainKey);
            }
            delete this._activeChains[key];
        };
        this._definition = definition;
        this._channel = channel;
    }
}
exports.InternalClientChainBase = InternalClientChainBase;
// ------------------------------------------------------------
// ------------------------------------------------------------
class InternalCFClientChain extends InternalClientChainBase {
    constructor(definition, channel) {
        super(definition, channel);
        this.begin = (payload) => __awaiter(this, void 0, void 0, function* () {
            const chain = new ActiveChain(uuid_1.v4());
            this._activeChains[chain.chainKey] = chain;
            return this.doNext(payload, chain.chainKey); // Can't resolve the conditional type internally - TLength is too complex
        });
    }
    // ------------------------------------------------------------
    doDispatch(message) {
        let chain = this._activeChains[message.chainKey];
        if (chain === undefined) {
            console.error("Invalid chain message - received a message for an unknown client-first chain:", message);
            return;
        }
        if (message.chainIndex !== chain.pendingIndex) {
            console.error(`Invalid chain message - received an out of sequence message. Dropping. Expected index: ${chain.pendingIndex} got: ${message.chainIndex}. `);
            this.dropChain(chain.chainKey);
            return;
        }
        //
        const decoded = this._definition.chain[message.chainIndex].decode(message.payload);
        if (Either.isLeft(decoded)) {
            console.error(`Invalid chain message - doesn't match the specified codec. Dropping chain. Message: ${message}`);
            this.dropChain(chain.chainKey);
            return;
        }
        if (chain.pendingHandler === undefined) {
            console.error("Got a message before we were ready. The server probably double-sent without waiting for our reply. Dropping chain.", message);
            this.dropChain(chain.chainKey);
            return;
        }
        chain.pendingHandler(decoded.right);
    }
}
exports.InternalCFClientChain = InternalCFClientChain;
// ------------------------------------------------------------
// ------------------------------------------------------------
class InternalSFClientChain extends InternalClientChainBase {
    constructor(definition, channel) {
        super(definition, channel);
        this._handlers = [];
        /**
         * Shorthand for handleSome with a filter that accepts ALL chains. This means that handleAll may only be called
         * once, and handleSome may not be called at all if handleAll is called.
         *
         * @param handler The handler for the chain message. All chain messages will be handled by this handler.
         */
        this.handleAll = (handler) => {
            if (this._handlers.length > 0) {
                throw "Cannot call handleAll - another handler has already been installed, handlers are ambiguous.";
            }
            this._handlers.push({
                handler,
                filter: () => true,
            });
        };
        /**
         * Exactly one handler is allowed to match any given chain message, so the set of all filters must be mutually
         * exclusive.
         *
         * @param handler The handler for the chain message, if the filter accepts it.
         * @param filter The filter to decide whether to accept or reject responsibility for a chain message.
         */
        this.handleSome = (handler, filter) => {
            this._handlers.push({
                handler,
                filter,
            });
        };
    }
    // ------------------------------------------------------------
    doDispatch(message) {
        let chain = this._activeChains[message.chainKey];
        if (chain === undefined && message.chainIndex !== 0) {
            console.error("Invalid chain message - received a message for an unknown server-first chain that isn't the first message:", message);
            return;
        }
        if (chain === undefined) {
            chain = new ActiveChain(message.chainKey);
            this._activeChains[message.chainKey] = chain;
        }
        if (message.chainIndex !== chain.pendingIndex) {
            console.error(`Invalid chain message - received an out of sequence message. Dropping. Expected index: ${chain.pendingIndex} got: ${message.chainIndex}. `);
            this.dropChain(chain.chainKey);
            return;
        }
        //
        if (message.chainIndex === 0) {
            // First message in the chain - we gotta set things up.
            const decoded = this._definition.chain[0].decode(message.payload);
            if (Either.isLeft(decoded)) {
                console.error(`Invalid chain message - doesn't match the specified codec. Dropping chain. Message: ${message}`);
                this.dropChain(chain.chainKey);
                return;
            }
            const eligibleHandlers = this._handlers.filter((registration) => registration.filter(decoded.right));
            if (eligibleHandlers.length === 0) {
                console.warn("Received chain that no handlers elected to handle. Dropping.");
                this.dropChain(chain.chainKey);
                return;
            }
            else if (eligibleHandlers.length > 1) {
                console.error("Multiple handlers indicated that they wanted to handle a chain. This is invalid. Dropping.", message);
                this.dropChain(chain.chainKey);
                return;
            }
            else {
                chain.pendingIndex++;
                const stage = {
                    value: decoded.right,
                    next: ((payload) => this.doNext(payload, message.chainKey)),
                };
                eligibleHandlers[0].handler(stage);
                return;
            }
        }
        else {
            const decoded = this._definition.chain[message.chainIndex].decode(message.payload);
            if (Either.isLeft(decoded)) {
                console.error(`Invalid chain message - doesn't match the specified codec. Dropping chain. Message: ${message}`);
                this.dropChain(chain.chainKey);
                return;
            }
            if (chain.pendingHandler === undefined) {
                console.error("Got a message before we were ready. The server probably double-sent without waiting for our reply. Dropping chain.", message);
                this.dropChain(chain.chainKey);
                return;
            }
            chain.pendingHandler(decoded.right);
        }
    }
}
exports.InternalSFClientChain = InternalSFClientChain;
//# sourceMappingURL=ClientChain.js.map